/* eslint-disable react/jsx-props-no-spreading */

import { MaskitoDateMode, maskitoDateOptionsGenerator } from '@maskito/kit'
import { useMaskito } from '@maskito/react'
import React, { InputHTMLAttributes, RefObject } from 'react'

import Input from '.'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  requiredMessage?: string | undefined
  privateData?: boolean
  mode?: MaskitoDateMode
}

const InputDate = ({ mode = 'mm/dd/yyyy', ...rest }: InputProps) => {
  const dateOptions = maskitoDateOptionsGenerator({
    mode,
    separator: '/',
  })

  const maskedDateRef = useMaskito({
    options: dateOptions,
  })

  return <Input inputRef={maskedDateRef as unknown as RefObject<HTMLInputElement>} {...rest} />
}

export default InputDate
